import { adminConstants } from "../constant/admin-constant";
import { alertActions } from "./alert-actions";
import { history } from "../../helper/history";
import { userService } from "../../services/user";

export const userActions = {
    storeUser,
    getUser,
    editUser,
    getUsers,
    deleteUser,
    getCurrentUser,
    updatePermission,
    getUsersPagination,
    getOrderUser,
    updateOrderModerator,
    getCustomerUsersPagination,
    storeCustomerUser,
    editCustomerUser,
    editUserProfile,
    changeUserPassword,
    signupCustomer,
    sendRecoveryEmail,
    resetUserPassword,
    getUserProfile,
    storeAdminUser,
};

function updatePermission(userId) {
    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                setTimeout(function () {
                    history.go(0);
                }, 500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHANGE_PRIMARY_USER_FAILURE,
            payload: error
        };
    }
}
function getCurrentUser() {
    return dispatch => {
        dispatch(request());
        return new Promise((resolve, reject) => {
            userService.getCurrentUser().then(
                user => {
                    if (user.token) {
                        localStorage.setItem("user", JSON.stringify(user));
                        dispatch(success(user));
                        resolve();
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
        });
    };

    function request() {
        return { type: adminConstants.CHECK_USER_PERMISSIONS_REQUEST };
    }
    function success(user) {
        return {
            type: adminConstants.CHECK_USER_PERMISSIONS_SUCCESS,
            payload: user
        };
    }
    function failure(error) {
        return {
            type: adminConstants.CHECK_USER_PERMISSIONS_FAILURE,
            payload: error
        };
    }
}

function storeUser(UserData) {
    return dispatch => {
        dispatch(request());
        return userService.storeUser(UserData).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.STORE_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.STORE_USER_FAILURE, payload: error };
    }
}

function storeAdminUser(UserData, id='') {
    return dispatch => {
        dispatch(request());
        return userService.storeAdminUser(UserData, id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.STORE_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.STORE_USER_FAILURE, payload: error };
    }
}

function editUser(UserData, id) {
    return dispatch => {
        dispatch(request());
        return userService.editUser(UserData, id).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.STORE_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.STORE_USER_FAILURE, payload: error };
    }
}

function storeCustomerUser(UserData) {
    return dispatch => {
        dispatch(request());
        return userService.storeCustomerUser(UserData).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.STORE_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.STORE_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.STORE_USER_FAILURE, payload: error };
    }
}

function getUser(id) {
    return dispatch => {
        dispatch(request());
        return userService.getUser(id).then(
            User => {
                dispatch(success(User));
                return User;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_USER_REQUEST };
    }
    function success(User) {
        return { type: adminConstants.GET_USER_SUCCESS, payload: User };
    }
    function failure(error) {
        return { type: adminConstants.GET_USER_FAILURE, payload: error };
    }
}

function editCustomerUser(UserData, userId, model) {
    return dispatch => {
        dispatch(request());
        return userService.editCustomerUser(UserData, userId, model).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.EDIT_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.EDIT_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.EDIT_USER_FAILURE, payload: error };
    }
}

function editUserProfile(UserData, model) {
    return dispatch => {
        return userService.editUserProfile(UserData, model).then(
            response => {
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };
}

function signupCustomer(UserData, userId, model) {
    return dispatch => {
        dispatch(request());
        return userService.signupCustomer(UserData, userId, model).then(
            response => {
                console.log(response.message);
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminConstants.SIGNUP_CUSTOMER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.SIGNUP_CUSTOMER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.SIGNUP_CUSTOMER_FAILURE, payload: error };
    }
}

function deleteUser(userId) {
    return dispatch => {
        dispatch(request());
        return userService.deleteUser(userId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                // setTimeout(function(){
                //     history.go(0);
                // }, 1500);
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.DELETE_USER_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.DELETE_USER_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.DELETE_USER_FAILURE, payload: error };
    }
}

function getUsers(companyId) {
    return dispatch => {
        dispatch(request());

        userService.getUsers(companyId).then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_USERS_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.GET_USERS_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.GET_USERS_FAILURE, payload: error };
    }
}

function getUsersPagination(page, filter, sort, pageSize) {
    return dispatch => {
        userService.getUsersPagination(page, filter, sort, pageSize).then(
            response => {
                dispatch({
                    type: adminConstants.PAGINATION_ADMIN_USERS_SUCCESS,
                    payload: response.result
                });
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}

function getCustomerUsersPagination(id, model, filter, page, sort, pageSize) {
    return dispatch => {
        dispatch(request());
        userService
            .getCustomerUsersPagination(id, model, filter, page, sort, pageSize)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() {
        return { type: adminConstants.PAGINATION_USERS_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.PAGINATION_USERS_SUCCESS,
            payload: response.result
        };
    }
    function failure(error) {
        return {
            type: adminConstants.PAGINATION_USERS_FAILURE,
            payload: error
        };
    }
}

function getOrderUser() {
    return dispatch => {
        dispatch(request());

        userService.getOrderUsers().then(
            response => {
                dispatch(success(response));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_USERS_ORDER_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.GET_USERS_ORDER_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return { type: adminConstants.GET_USERS_ORDER_FAILURE, payload: error };
    }
}

function updateOrderModerator(data, orderId) {
    return dispatch => {
        dispatch(request());

        userService.updateOrderModerator(data, orderId).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.UPDATE_USERS_MODERATOR_REQUEST };
    }
    function success(response) {
        return {
            type: adminConstants.UPDATE_USERS_MODERATOR_SUCCESS,
            payload: response
        };
    }
    function failure(error) {
        return {
            type: adminConstants.UPDATE_USERS_MODERATOR_FAILURE,
            payload: error
        };
    }
}

function changeUserPassword(userId, UserData) {
    return dispatch => {
        dispatch(request());
        return userService.changeUserPassword(userId, UserData).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.CHANGE_USER_PASSWORD_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.CHANGE_USER_PASSWORD_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.CHANGE_USER_PASSWORD_FAILURE, payload: error };
    }
}

function sendRecoveryEmail(data) {
    return dispatch => {
        dispatch(request());
        return userService.sendRecoveryEmail(data).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.SEND_RECOVERY_EMAIL_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.SEND_RECOVERY_EMAIL_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.SEND_RECOVERY_EMAIL_FAILURE, payload: error };
    }
}

function resetUserPassword(data) {
    return dispatch => {
        dispatch(request());
        return userService.resetUserPassword(data).then(
            response => {
                dispatch(success(response));
                dispatch(alertActions.success(response.message));
                return response;
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminConstants.RESET_USER_PASSWORD_REQUEST };
    }
    function success(response) {
        return { type: adminConstants.RESET_USER_PASSWORD_SUCCESS, payload: response };
    }
    function failure(error) {
        return { type: adminConstants.RESET_USER_PASSWORD_FAILURE, payload: error };
    }
}


function getUserProfile() {
    return dispatch => {
        dispatch(request());
        return userService.getUserProfile().then(
            user => {
                dispatch(success(user));
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: adminConstants.GET_USER_PROFILE_REQUEST };
    }
    function success(user) {
        return { type: adminConstants.GET_USER_PROFILE_SUCCESS, payload: user };
    }
    function failure(error) {
        return { type: adminConstants.GET_USER_PROFILE_FAILURE, payload: error };
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/user-actions.jsx